<div [attr.class]="layout">
  <div class="container">
    <span>
      {{ 'EMAIL_TEMPLATES.PREVIEW.PREVIEWING_AS' | translate }}
      @if (contactData) {
        @if (contactData.name && contactData.name !== '') {
          <span class="name">{{ contactData.name }}</span>
        }
        @if (contactData.email && contactData.email !== '') {
          <span class="name"> ({{ contactData.email }})</span>
        }
      } @else if (business) {
        @if (business?.name && business?.name !== '') {
          <span class="name"> {{ business.name }}</span>
          @if (showWarning) {
            <mat-icon [glxyTooltip]="warningKey | translate">warning_filled</mat-icon>
          }
        }
      }
      <button class="change-button" (click)="openDialog()">{{ 'EMAIL_TEMPLATES.PREVIEW.CHANGE' | translate }}</button>
    </span>
  </div>
  <button mat-stroked-button (click)="openPreviewEmailDialog()" class="test-email-button">
    <span>{{ 'CAMPAIGN_DETAILS.EDIT_TEMPLATE.SEND_TEST_EMAIL' | translate }}</span>
  </button>
</div>
